import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../actions';

class VimeoRedirector extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(this.props.location.search);
        if (urlParams.get('error') === 'access_denied' && urlParams.get('whiteRedirect').length > 0) {
            window.location.replace(`${urlParams.get('whiteRedirect')}?vimeoDenied=true`);
        } else {
            this.redirect();
        }
    }

    componentDidUpdate(prevProps) {
        const urlParams = new URLSearchParams(this.props.location.search);
        if (!prevProps.versions.select.vimeoToken && this.props.versions.select.vimeoToken) {
            window.location.replace(`${urlParams.get('whiteRedirect')}?vimeo=true`);
        }
        if (prevProps.alerts?.data?.length !== this.props.alerts?.data?.length
            && this.props.alerts?.data?.length > 0) {
            window.location.replace(`${urlParams.get('whiteRedirect')}?vimeoDenied=true`);
        }
    }

  redirect = () => {
      // Go To Vimeo
      const urlParams = new URLSearchParams(this.props.location.search);
      let apiRoot = document.location.origin;
      if (apiRoot.includes('ministryone.com')) {
          apiRoot = 'https://app.ministryone.com';
      }
      if (apiRoot.includes('ministryonestaging.com')) {
          apiRoot = 'https://app.ministryonestaging.com';
      }
      const redirect = `${apiRoot}/vimeo-authentication${this.props.location.search}`;

      if (!urlParams.get('code')) {
          window.location.replace(`https://api.vimeo.com/oauth/authorize?response_type=code&client_id=d076c523b1f046e9d19943e0e2163e4896475897&state=something&redirect_uri=${redirect}`);
      } else {
      // When code comes back send it to the backend to get a token
          const whiteURL = urlParams.get('whiteRedirect');
          const projectId = whiteURL.slice(-52, -16);
          const code = urlParams.get('code');
          this.props.actions.getVimeoToken(code, projectId, redirect);
      }
  };

  render() {
      return (
          <div />
      );
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VimeoRedirector);
